import style from './Order.module.css';
import addComma from '../../../Functions/numberFormat';
import { useEffect, useState } from 'react';
import useAxios from '../../../hooks/useAxios';
import { BaseURL } from '../../../config/axios';
import Payments from './Payments';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Badge } from '@nextui-org/react';

const Order = ({ setOnOrder }) => {
    const { AxiosPrivate } = useAxios()
    const push = useNavigate();

    const [searchParams] = useSearchParams();
    const orderID = searchParams.get('order');
    const queries = Object.fromEntries([...searchParams.entries()].filter(([key]) => key !== 'order'));
    const [order, setOrder] = useState()

    useEffect(() => {
        if (orderID) {
            const get = async () => {
                await AxiosPrivate.get(`order/show/${orderID}`)
                    .then(res => setOrder(res.data.data))
                    .catch(err => alert(err.response?.data.message))
            }
            get()
        }
    }, [orderID])


    const OrderList = () => {
        setOnOrder()
        const newParams = new URLSearchParams(queries);
        push({ pathname: window.location.pathname, search: `?${newParams.toString()}` }, { replace: true });
    }
    const handlePay = async () => {
        await AxiosPrivate.post(`/order/repay/${order.id}`)
            .then(res => window.location.replace(res.data.data.redirect_url))
            .catch(err => alert(err.response?.data.message || 'اتصال به درگاه پرداخت ناموفق بود'))

    }
    const handleCancell = async () => {
        if (window.confirm('از لغو سفارش خود مطمئن هستید؟'))
            await AxiosPrivate.patch(`/order/update/${order.id}`, { order_status_id: 5 })
                .then(res => {
                    alert(res.data.message || 'سفارش لغو شد');
                    OrderList()
                })
                .catch(err => alert(err.response?.data.message || 'سفارش لغو نشد'))
    }

    return (
        <>
            {!!order ? <div className={style.order} dir='auto'>
                <div className={style.container}>
                    <div className='flex items-center gap-4 border-b p-6'>
                        <button className={style.go_back} onClick={() => OrderList()}><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"></path></svg></button>
                        <div className={style.order_code}>
                            <p>جزئیات سفارش</p>
                        </div>
                    </div>
                    <div className={style.heading}>
                        <div className={style.info}>
                            {(order.order_status_id == 1) && <div className='flex gap-4 mb-3 border-b pb-3'>
                                <div onClick={handlePay}
                                    className='centerOfParent bg-blue-500 text-white px-3 py-2 rounded-lg cursor-pointer'>پرداخت
                                </div>
                                <div onClick={handleCancell}
                                    className='centerOfParent bg-red-500 text-white px-3 py-2 rounded-lg cursor-pointer'>لغو
                                    سفارش
                                </div>
                            </div>}
                            <div className={[style.head_top, style.text].join(' ')}>
                                <div>
                                    کد سفارش <span>{order.code}</span>
                                </div>
                                <div className={style.icon}><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"></path></svg></div>
                                <div>
                                    تاریخ ثبت سفارش <span>{new Date(order.created_at).toLocaleDateString('fa-IR', {
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric'
                                    })}</span>
                                </div>
                            </div>
                            <div className={style.head_address}>
                                <div className={[style.receiver, style.text].join(' ')}>
                                    <div>
                                        تحویل گیرنده <span>{order.address.name}</span>
                                    </div>
                                    <div className={style.icon}><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"></path></svg></div>
                                    <div>
                                        شماره موبایل <span>{order.address.number}</span>
                                    </div>
                                </div>
                                <div className={style.text}>
                                    <div>
                                        آدرس <span>{order.address.city} - {order.address.text}</span>
                                    </div>
                                </div>
                                <div className={style.text}>
                                    <div>
                                        کد پستی: <span>{order.address.postal_code}</span>
                                    </div>
                                </div>
                            </div>
                            <div className={[style.head_top, style.text, '!pb-0 pt-4 border-t !border-b-0'].join(' ')}>
                                <div>
                                    وضعیت <span>{order.order_status.title}</span>
                                </div>
                                <div className={style.icon}><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"></path></svg></div>
                                <div>
                                    کد پیگیری سفارش <span>{order.postal_reference.code || 'تعریف نشده'}</span>
                                </div>
                                <div className={style.icon}><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"></path></svg></div>
                                <div>
                                    روش ارسال <span>{order.postal_reference.method || 'تعریف نشده'}</span>
                                </div>
                            </div>
                        </div>
                        <div className={style.head_pay}>
                            <div className={style.text}>
                                <div>
                                    مبلغ <span className={style.toman}>{addComma(order.price)}</span>
                                </div>
                                {!!order.discount && <>
                                    <div className={style.icon}><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"></path></svg></div>
                                    <div>
                                        سود شما از خرید <span
                                            className={style.toman}>{addComma(order.discount_amount)}</span>
                                    </div>
                                </>}
                                <div className={style.icon}><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"></path></svg></div>
                                <div>
                                    <span>پرداخت اینترنتی</span>
                                </div>
                            </div>
                            {!!order.order_payments.length && <Payments data={order.order_payments} />}
                        </div>
                    </div>
                    <div className={style.main}>
                        <div className={style.content}>
                            <div className={style.products}>
                                {order.order_details?.map(p => {
                                    return (
                                        <div className={style.tEl_7HqZy} key={p.id}>
                                            <div className={style.LbOT_Plwz33}>
                                                <Link to={`/product/${p.painting?.slug}`}>
                                                    <Badge content={parseInt(p.count)} color="primary"
                                                        placement='bottom-left'
                                                        classNames={{ base: 'shrink-0 centerOfParent h-full' }}>
                                                        <img width={100} height={100}
                                                            className='rounded-lg w-full h-full object-cover'
                                                            src={BaseURL + p.painting.image?.path}
                                                            alt={p.painting?.title} />
                                                    </Badge>
                                                </Link>
                                                <div className='grow'>
                                                    <h3 className={style.RxQOi_5_ed}>{p.painting.title}</h3>
                                                    <div className={style.MncBgTfd_Pr}>
                                                        <div className='flex items-center gap-1'>
                                                            <svg stroke="currentColor" fill="currentColor" stroke-width="0" version="1.1" viewBox="0 0 17 17" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><g></g><path d="M5 0v17h7v-17h-7zM11 16h-5v-0.984h2v-1h-2v-1.016h1v-1h-1v-1h2v-1h-2v-0.984h1v-1h-1v-1h2v-1h-2v-1.016h1v-1h-1v-1h2v-1h-2v-1h5v15z"></path></svg>
                                                            <div
                                                                className="flex items-center gap-2 text-sm font-medium">
                                                                <p>ارتفاع: {p.height}</p>
                                                                <p>عرض: {p.width}</p>
                                                            </div>
                                                        </div>
                                                        <div className='flex items-center gap-2 text-sm font-medium'>
                                                            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 256 256" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M198,80v32a6,6,0,0,1-12,0V86H160a6,6,0,0,1,0-12h32A6,6,0,0,1,198,80ZM96,170H70V144a6,6,0,0,0-12,0v32a6,6,0,0,0,6,6H96a6,6,0,0,0,0-12ZM230,56V200a14,14,0,0,1-14,14H40a14,14,0,0,1-14-14V56A14,14,0,0,1,40,42H216A14,14,0,0,1,230,56Zm-12,0a2,2,0,0,0-2-2H40a2,2,0,0,0-2,2V200a2,2,0,0,0,2,2H216a2,2,0,0,0,2-2Z"></path></svg>
                                                            <p>فریم: {p.frame?.title || 'ندارد'}</p>
                                                        </div>
                                                        <div className='flex items-center gap-2 text-sm font-medium'>
                                                            <svg stroke="currentColor" fill="none" stroke-width="0" viewBox="0 0 15 15" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.4999 0.999994C14.2237 0.999994 13.9999 1.22385 13.9999 1.49999L13.9999 5.99995L9.99992 5.99995C9.44764 5.99995 8.99993 6.44766 8.99993 6.99994L8.99993 7.99994C8.99993 8.55222 9.44764 8.99993 9.99992 8.99993L13.9999 8.99993L13.9999 13.4999C13.9999 13.776 14.2237 13.9999 14.4999 13.9999C14.776 13.9999 14.9999 13.776 14.9999 13.4999L14.9999 1.49999C14.9999 1.22385 14.776 0.999994 14.4999 0.999994ZM4.99996 5.99995L0.999992 5.99995L0.999992 1.49999C0.999992 1.22385 0.776136 0.999994 0.499996 0.999994C0.223856 0.999994 -9.7852e-09 1.22385 -2.18557e-08 1.49999L4.07279e-07 13.4999C3.95208e-07 13.776 0.223855 13.9999 0.499996 13.9999C0.776136 13.9999 0.999992 13.776 0.999992 13.4999L0.999992 8.99993L4.99996 8.99993C5.55224 8.99993 5.99995 8.55222 5.99995 7.99993L5.99995 6.99994C5.99995 6.44766 5.55224 5.99995 4.99996 5.99995Z" fill="currentColor"></path></svg>
                                                            <p>پاسپارتو: {p.passpartout ? p.passpartout + ' سانتی متر' : 'ندارد'}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div></div>
                                                <div className='flex items-center gap-2'>
                                                    <label className='font-bold'>قیمت: </label>
                                                    <p className={style.price_3Sproduct}>{addComma(p.price)} تومان</p>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div> : <div className='w-full centerOfParent'>درحال بارگزاری ...</div>}
        </>
    );
};

export default Order;